/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_Verdict_ByInputs */

const en_pc_rv_verdict_by = /** @type {(inputs: Pc_Rv_Verdict_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our verdict`)
};

const zh_pc_rv_verdict_by = /** @type {(inputs: Pc_Rv_Verdict_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们的结论`)
};

/**
* | output |
* | --- |
* | "Our verdict" |
*
* @param {Pc_Rv_Verdict_ByInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_verdict_by = /** @type {((inputs?: Pc_Rv_Verdict_ByInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_Verdict_ByInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_verdict_by(inputs)
	return zh_pc_rv_verdict_by(inputs)
});
export { pc_rv_verdict_by as "pc.rv.verdict_by" }